import React from 'react'
import PropTypes from 'prop-types'
import { Button, Dialog, DialogActions, DialogContent, useMediaQuery } from '@material-ui/core'
import { MODAL_STYLES } from 'asterX-UI/theme.constant'
import ModalTitle from 'asterX-UI/Modals/ModalTitle'
import { useInfoModalStyles } from 'asterX-UI/Modals/modals.styles'
import { GRAY_COLORS } from 'asterX-UI/colors.constant'

const InfoModal = ({ open, onClose, variant = '', title = '', btnText = 'OK', isButtonHidden, maxWidth, ...other }) => {
  const classes = useInfoModalStyles({ variant, maxWidth })
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('lg'))

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={isMobile ? 'xs' : 'sm'}
      classes={{ paper: classes.paper }}
      fullWidth
      {...other}
    >
      <ModalTitle onClose={onClose} variant={variant} style={{ color: GRAY_COLORS[800] }}>
        {title}
      </ModalTitle>
      <DialogContent>{other.children}</DialogContent>
      {isButtonHidden ? (
        ''
      ) : (
        <DialogActions>
          <Button variant={'outlined'} fullWidth onClick={onClose}>
            {btnText}
          </Button>
        </DialogActions>
      )}
    </Dialog>
  )
}
export default InfoModal
InfoModal.propTypes = {
  title: PropTypes.string,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  variant: PropTypes.oneOf(MODAL_STYLES.variant),
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string])
}
